import React from 'react';

import {StyledGrid} from 'presentation/components';

import {AppointmentCardSkeleton} from 'presentation/modules/myAppointments/ui/components/AppointmentCardSkeleton';
import {AppointmentDetailsContentWrapper} from './styles';

export function MyAppointmentDetailsLoading() {
	return (
		<AppointmentDetailsContentWrapper>
			<StyledGrid.Root>
				<StyledGrid.Item sm={12} md={12} lg={8}>
					<AppointmentCardSkeleton />
				</StyledGrid.Item>
				<StyledGrid.Item sm={12} md={12} lg={4}>
					<AppointmentCardSkeleton />
				</StyledGrid.Item>
			</StyledGrid.Root>
		</AppointmentDetailsContentWrapper>
	);
}
